import { useState, useEffect } from 'react';
import {
  fetchUserMovies,
  getRequestList,
  approveUserRequest,
  denyUserRequest,
  canAdd,
  requestListAccess,
  fetchUserMoviesRealTime,
  getListName } from '../../firebase';
import { selectUsers } from '../store/usersSlice';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

// Components
import MovieList from '../MovieList/MovieList';
import Button from '../Button/Button';
import LoadingScreen from '../Loading/LoadingScreen';
import AddMovieModal from '../AddMovieModal/AddMovieModal';
import ListInfoModal from '../ListInfoModal/ListInfoModal';

const MainPage = () => {
  const { listId } = useParams();
  const [isAddMovieModalOpen, setAddMovieModalOpen] = useState(false);
  const [isListInfoOpen, setListInfoOpen] = useState(false);
  const user = useSelector(selectUsers);
  const [randomMovie, setRandomMovie] = useState('');
  const [pendingList, setPendingList] = useState([]);
  const [canView, setView] = useState(false);
  const [moviesList, setMoviesList] = useState({});
  const [isPageLoading, setIsPageLoading] = useState(true);
  const [listName, setListName] = useState("");

  useEffect(() => {
    if (!user.currentUser?.id || !listId) {
      return;
    }

    let isMounted = true;
    let unsubscribe;

    const loadPage = async () => {
      try {
        const allowed = await canAdd(user.currentUser.id, listId);

        if (!isMounted) {
          return;
        }

        setView(allowed);

        if (!allowed) {
          setIsPageLoading(false);
          return;
        }

        unsubscribe = fetchUserMoviesRealTime(listId, setMoviesList);

        const listName =  await getListName(user.currentUser.listsId, listId);

        if (isMounted) {
          setListName(listName || "");
        }

        const pendingData = await getRequestList(listId);
        if (isMounted) {
          setPendingList(pendingData || []);
        }
      } catch (error) {
        console.error("Error loading list page:", error);

        if (isMounted) {
          setView(false);
        }
      } finally {
        if (isMounted) {
          setIsPageLoading(false);
        }
      }
    };

    // const getPending = async () => {
    //   const pendingData = await getRequestList(listId);

    //   if (isMounted && pendingData && pendingData.length > 0) {
    //     setPendingList(pendingData);
    //   }
    // };

    // const checkViewer = async() => {
    //   const result = await canAdd(user.currentUser.id, listId);
    //   if (isMounted) {
    //     setView(result);
    //     setIsPageLoading(false);
    //   }
    // }

    // const grabListName = async() => {
    //   const result = await getListName(user.currentUser.listsId, listId);
    //   if (isMounted) {
    //     setListName(result);
    //   }
    // }

    // //const unsubscribe = fetchUserMoviesRealTime(listId, setMoviesList);
    // checkViewer();
    // getPending();
    // grabListName();
    loadPage();

    return () => {
      isMounted = false;
      if (unsubscribe) unsubscribe();
    }

  }, [listId, user?.currentUser?.id, user?.currentUser?.listsId]);

  if (user.loading || isPageLoading) {
    return <LoadingScreen />
  }

  const randomSelect = async (e) => {
    e.preventDefault();
    const moviesForSelection = await fetchUserMovies(listId);
    if (Object.keys(moviesForSelection).length === 0) {
      return;
    }

    const movieArr = Object.values(moviesForSelection)
    const randomIndex = Math.floor(Math.random() * movieArr.length)
    setRandomMovie(movieArr[randomIndex].movieName);
  }

  const approveUser = (requestId) => {
    approveUserRequest(requestId, listId, pendingList, user.currentUser.listsId);
    alert("User approved! Refresh page to see updated page.")
  }

  const denyUser = (requestId) => {
    denyUserRequest(requestId, listId, pendingList);
    alert("User denied! Refresh page to see updated page.")
  }

  const requestAccess = (e) => {
    e.preventDefault();
    requestListAccess(user.currentUser.name, user.currentUser.email, user.currentUser.id, listId, user.currentUser.collabId);
    alert("Access Requested. Thank you!")
  }


  return (
    <>
      {canView ?
        <div className="Movie-List">
          <h1>{listName}</h1>
          {pendingList.length > 0 && pendingList.map(({ requestId, name, email }) => (
                <li key={requestId}>
                  <div className="mainPageButtons">
                    <p>You have pending request from {email}, {name}!</p>
                    <button onClick={() => approveUser(requestId)}>✅</button>
                    <button onClick={() => denyUser(requestId)}>❌</button>
                  </div>
                </li>      
          ))}
          {randomMovie && <p>Random movie is: {randomMovie}</p>}
          <div>
            <Button buttonText="Select random movie!" handleFunction={randomSelect}/>
            <button className="mainPageButtons" onClick={() => setAddMovieModalOpen(true)}>Add Movie</button>
            <button className="mainPageButtons" onClick={() => setListInfoOpen(true)}>List Info</button>
          </div>
          <AddMovieModal
            isOpen={isAddMovieModalOpen}
            onClose={() => setAddMovieModalOpen(false)}
            user={user}
            listId={listId}
          />
          <ListInfoModal
            isOpen={isListInfoOpen}
            onClose={() => setListInfoOpen(false)}
            listsId={user.currentUser.listsId}
            listId={listId}
            listSize={Object.keys(moviesList).length}
          />
          <MovieList listId={listId} moviesList={moviesList} />
        </div>
        :
        <div className="Movie-List">
          <h1>You can't access these movies yet!</h1>
          <Button buttonText="request access here!" handleFunction={requestAccess} />
        </div>
      }
    </>
  )
}

export default MainPage;
